import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container", "suggestions", "hiddenField"]
  static values = {
    availableTags: Array,
    inputPlaceholder: String
  }

  connect() {
    this.filteredTags = []
    this.setupEventListeners()
  }

  setupEventListeners() {
    // Input event for showing suggestions
    this.inputTarget.addEventListener('input', (e) => {
      this.showSuggestions(e.target.value)
    })

    // Keyup event for adding tags
    this.inputTarget.addEventListener('keyup', (e) => {
      if (e.key === 'Enter' || e.key === "Return" || e.key === "Tab" || e.key === " " || e.key === ",") {
        const tagName = e.target.value.trim()
        const currentTags = this.getCurrentTags()

        if (!!tagName && !currentTags.includes(tagName)) {
          this.addTag(tagName)
        }

        this.inputTarget.value = ''
        this.hideSuggestions()
        return
      }

      if (e.key === 'ArrowDown' && this.filteredTags.length > 0) {
        e.preventDefault()
        const firstSuggestion = this.suggestionsTarget.querySelector('div')
        if (firstSuggestion) firstSuggestion.focus()
      }

      if (e.key === 'Escape') {
        this.hideSuggestions()
      }
    })

    // Prevent form submission on enter
    this.inputTarget.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
      }
    })

        // Hide suggestions when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.inputTarget.contains(e.target) &&
          !this.suggestionsTarget.contains(e.target)) {
        this.hideSuggestions()
      }
    })
  }

  showSuggestions(filter = '') {
    const currentTags = this.getCurrentTags()

    this.filteredTags = this.availableTagsValue.filter(tag =>
      tag.toLowerCase().includes(filter.toLowerCase()) &&
      !currentTags.includes(tag)
    )

    if (this.filteredTags.length > 0 && filter !== '') {
      this.suggestionsTarget.innerHTML = ''
      this.filteredTags.forEach(tag => {
        const suggestion = document.createElement('div')
        suggestion.className = 'px-3 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-neutral-700 text-gray-900 dark:text-gray-100'
        suggestion.textContent = tag
        suggestion.addEventListener('click', () => {
          this.addTag(tag)
          this.inputTarget.value = ''
          this.hideSuggestions()
        })
        this.suggestionsTarget.appendChild(suggestion)
      })
      this.suggestionsTarget.classList.remove('hidden')
    } else {
      this.hideSuggestions()
    }
  }

  hideSuggestions() {
    this.suggestionsTarget.classList.add('hidden')
  }

  addTag(tagName) {
    // Remove commas from tagName
    tagName = tagName.replace(/,/g, '')

    const tagElement = document.createElement('span')
    tagElement.classList.add('py-1', 'pl-2', 'bg-gray-100', 'tag', 'mr-2', 'mt-2', 'inline-block', 'dark:bg-neutral-900')
    tagElement.innerHTML = `
      ${tagName}<span class="close hover:text-red-500" data-action="click->tags#removeTag" data-tag-name="${tagName}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="inline-block h-3">
          <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
        </svg>
      </span>
    `

    this.containerTarget.appendChild(tagElement)
    this.updateHiddenField()
  }

  removeTag(event) {
    const tagName = event.currentTarget.getAttribute('data-tag-name')
    const tagElement = event.currentTarget.closest('.tag')

    if (tagElement) {
      tagElement.remove()
      this.updateHiddenField()
    }
  }

  getCurrentTags() {
    return this.hiddenFieldTarget.value.split(',').filter(tag => tag.trim() !== '')
  }

  updateHiddenField() {
    const tagElements = this.containerTarget.querySelectorAll('.tag')
    const tags = Array.from(tagElements).map(element => {
      const closeButton = element.querySelector('.close')
      return closeButton ? closeButton.getAttribute('data-tag-name') : element.textContent.trim()
    }).filter(tag => tag !== '')

    this.hiddenFieldTarget.value = Array.from(new Set(tags)).join(',')
  }
}